<template>
<div class="topclass">
  <table v-show="data.length > 0">
  <thead>
    <tr>
      <th v-for="key in columns" >{{key.value}}</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="entry in data" @click="clicked(entry)">
      <td v-for="key in columns" ><div v-show="!key.button">{{entry[key.key]}}{{key.append}}</div><div v-show="key.button"><button type="button" class="btn btn-danger RightButton" @click.stop="BClicked(entry)">X</button></div></td>
    </tr>
  </tbody>
</table>
</div>
</template>

<script>
export default {
  props: {
    data: Array,
    columns: Array
  },
  data: function () {
    return {}
  },
  methods: {
    clicked: function (obj) {
      //this.$dispatch('GridRowClicked', this.name, obj)
      this.$emit('GridRowClicked',obj)
    },
    BClicked: function (obj) {
      //this.$dispatch('GridButtonClicked', this.name, obj)
      this.$emit('GridButtonClicked',obj)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  font-family: Helvetica Neue, Arial, sans-serif;
  font-size: 14px;
  color: #444;
}

table {
  align-items: center;
  width: 100%;
  border: 2px solid gray;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0px 0px 10px darkgrey;
}

th {
  background-color: lightgrey;
  color: black;
  -webkit-user-select: none;
  -moz-user-select: none;
  -user-select: none;
  cursor: auto;
}

td {
  // background-color: red;
  cursor: pointer;
}

.RightButton {
  float: right;
}

.topclass {
  padding: 20px;
  padding-top: 0px;
}

.alignright {
  text-align: right;
}

.bold {
  font-weight: bold;
}

tr {
  text-align: left;
  white-space: pre-wrap;
  border: 2px solid gray;
  color: #000000;
}

tr:nth-child(odd) {
  background-color: #f2f2f2;
  color: #000000;
}

tr:hover {
  background-color: #cde9ef;
  cursor: pointer;
}

th, td {
  min-width: 120px;
  padding: 10px 20px;
}

</style>



// WEBPACK FOOTER //
// grid.vue?785c38f6